<template>
<div>
    <loading-box  v-if="loading"/>

    <div class="grid-container">
        
        <div class="grid-item">
            <datatable-filter ref="filter" class="table-filter" :class="filterPosition" @filter="filter($event)"/>
        </div>

        <div class="grid-item">
            <div class="table-responsive">
                <table ref="table"
                    class="dt-responsive display nowrap dataTable dtr-inline"
                    v-on:click.native="tableClicked"
                    :id="elementId" 
                    :class="[ ...(datatableClasses || []), loading ? 'loading-results' : '', isCollapsed ? 'collapsed' : '' ]"
                >
                </table>
            </div>
        </div>
    </div>

</div>
</template>

<script>

//Util
import _ from 'lodash';
import dt from 'datatables';

// import 'datatables.net-responsive';
// import 'datatables.net-rowreorder';
import $ from 'jquery';

import 'datatables.net-rowreorder';
import 'datatables.net-responsive';

import {language as dtLanguage} from '../Util/data-table';
import {promptWithIconV2 as prompt} from '../../../../Core/Util/prompt';

//Mixins
import guidMixin from '../../../../Core/Util/Mixins/guid';
import cultureMixin from '../../../../Core/Util/Mixins/culture';
import resourceMixin from '../../../../Core/Util/Mixins/resources';

//Components
import LoadingBox from '../../../../Core/Components/Util/LoadingBox.vue';
import Filter from './DataTableFilter.vue';

const textRenderer = $.fn.dataTable.render.text();

const defaultContentType = {
    button: 'button'
};

const filterPositions = {
    right: 'right',
    left: 'left'
}

export {
    defaultContentType,
    filterPositions,
    textRenderer
}

export default {
    name: 'data-table',
    components: {
        LoadingBox,
        'datatable-filter': Filter
    },
    mixins: [ guidMixin, cultureMixin, resourceMixin],
    created() {
        const vm = this;

        // Custom buttons need to consist of a column containing at least: 
        // defaulcontent with html.
        // defaultContentType.button (Exported by this vue)
        // name.

        // If any of these properties are not providded. The click handling will break.
        // Click handler will emit an event with the button name.

        const customButtons = this.columns.filter(
            column => column.defaultContent && column.type === defaultContentType.button
        );

        customButtons.forEach((button) => {
            button.defaultContent = 
                `<div ${vm.$options._scopeId} class="custom-button" name="${ button.name }">` + 
                    button.defaultContent + 
                `</div>`;
        });
    },
    mounted() {
        //Add a select column if select was enabled.
        if(this.mergedOptions.select.enabled) {
            this.addSelectColumn();
        }

        //Add edit button if edit was enabled.
        if(this.mergedOptions.edit.enabled) {
            this.addEditColumn();
        }

        //Vue won't listen to events not from its own components
        //as a workaround; we should attach our own event listener
        this.$refs.table.addEventListener('click', this.tableClicked);

        this.reloadDataTable();
    },
    methods: {
        filter(filterText) {
            this.currentFilter = filterText;
            this.table.search(filterText).draw();
        },
        tableClicked(e) {
            const vm = this;
            const target = $(e.target);

            const customButton = target.parents('.custom-button');

            if(target.is('td')) {
                const row = vm.getRow(target);
                vm.$emit('clicked', vm.getRowData(row));

            } else if(customButton.length > 0) {
                const row = vm.getRow(target);
                vm.$emit(`${customButton.attr('name')}`, vm.getRowData(row));

            } else if(target.hasClass('custom-checkbox') && !target.hasClass('check-all')) {
                vm.handleSelect(target);

            } else if(target.hasClass('datatable-edit') && vm.canEdit) {
                vm.handleEdit(target);
            }
        },        
        handleEdit(target) {
            this.editingRow = true;

            const row = this.getRow(target);
            this.rowToEdit = row;
            
            const data = this.getRowData(row);
            this.$emit('edit', data);
        },
        handleSelect(target) {          
            const row = this.getRow(target);
            const data = this.getRowData(row);

            const checked = target.prev().is(':checked');

            //This method is fired before the change event.
            //So counter intuitively, the logic is inversed.
            if(checked) {
                this.$emit('unselected', data);
            } else {
                this.$emit('selected', data);
            }
        },
        getRow(target) {
            let row = target.closest('tr');

             //If the row was collapsed by responsive tables, we want the parent to get all our data.
            if(row.hasClass('child')) {
                row = row.prev();
            }

            return row;
        },
        getRowData(row) {
            const data = this.table.row(row).data();
            return data;
        },
        setRowData(row) {
            this.table.row(this.rowToEdit).data(row).draw();
            this.finishEdit();
        },
        finishEdit(row) {
            this.rowToEdit = null;
            this.editingRow = false;
        },
        reloadDataTable() {
            const vm = this;
            const table = $(vm.$refs.table);
            
            //destroy old datatable.
            if($.fn.dataTable.isDataTable(`#${vm.elementId} `)) {
                table.DataTable().destroy();
            }

            //re initialize datatable.
            vm.table = table.DataTable(vm.mergedDataTableOptions); 
            vm.isCollapsed = table.hasClass('collapsed');

            //Add select all button if enabled.
            if(vm.mergedOptions.select.enabled) {
                vm.addCheckAll();
            }

            //Bootstrap datatables adds a width that breaks zooming
            table.attr('style', '');

            //re apply any open filters and re filter table
            if(vm.data.length !== 0) {
                vm.$refs.filter.focus();
                vm.filter(vm.currentFilter);
            }
        },
        addSelectColumn() {
            const column = {
                targets: -1,
                orderable: false,
                defaultContent: this.checkbox,
                data: null,
                title: ''
            }

            if(!this.columns.find((c) => c.defaultContent === this.checkbox)) {
                this.columns.unshift(column);
            }
        },
        addEditColumn() {
            const column = {
                targets: -1,
                defaultContent: this.editBtn,
                data: null,
                title: '',
                responsivePriority: -1
            }

            this.columns.push(column);
        },
        addCheckAll() {
            const vm = this;
            const table = $(vm.$refs.table);
            const th = table.find('thead').find('th').eq(0).append(vm.checkbox);
            const selectAll = th.find('.custom-checkbox');
            
            selectAll.addClass('check-all');

            function toggleSelect(checked) {
                $('input[type="checkbox"]', vm.table.cells().nodes())
                    .prop('checked', checked);

                vm.$emit(checked ? 'select-all' : 'unselect-all');
            }
            
            selectAll.click(() => {
                const checked = !selectAll.prev().is(':checked');

                if(checked) {
                    if(vm.itemsExceedPageLength) {
                        prompt(
                            vm.resource('DataTable_SelectAll_Prompt_Title'), 
                            vm.resource('DataTable_SelectAll_Prompt_Body'), 
                            'fa fa-exclamation-triangle text-warning').then(
                            () => { toggleSelect(checked) },
                            () => { selectAll.prev().prop('checked', false); }
                        );
                    } else {
                        toggleSelect(checked);
                    }
                } else {
                    toggleSelect(checked);
                }
            });
        }
    },
    watch: {
        data(value) {
            this.reloadDataTable();
            this.$emit('unselect-all');
        },
    },
    computed: {
        canEdit() {
            return this.mergedOptions.edit.enabled && !this.editingRow;
        },
        mergedDataTableOptions() {
            const language = this.culture().name == 'nl' ? dtLanguage.dutch : {};
            const vm = this;

            return _.merge({}, {
                    data: vm.data, 
                    columns: vm.encodedColumns,
                    language: vm.culture().name == 'nl' ? dtLanguage.dutch : {},
                    sDom: '<"top"i>rt<"bottom"lp> <"clear">',
                    responsive: true
                }, vm.datatableOptions);
        },
        mergedOptions() {
            return _.merge({}, this.defaultOptions, this.options);
        },
        itemsExceedPageLength() {
            return this.table.page.info().length < this.data.length;
        },
        editBtn() {
            return this.mergedOptions.edit.iconButton ?
                [   `<a ${this.$options._scopeId} href="javascript:void(0)" class="mdb-icon-btn datatable-edit">`,
                        `<i class="fa fa-pencil datatable-edit"></i>`,
                    `</a>`].join('') :

                [   `<button ${this.$options._scopeId} class="btn btn-secondary btn-sm datatable-edit">`,
                        `<i class="fa fa-pencil datatable-edit"></i>${this.resource('Button_Edit')}`,
                    `</button>`].join('');
        },
        checkbox() {
            return [
                `<label ${this.$options._scopeId} class="checkbox-wrapper">`,
                    `<input type="checkbox">`,
                    `<span class="custom-checkbox"></span>`,
                `</label>`
            ].join('');
        },
        encodedColumns() {
            return this.columns.map((column) => {
                return _.merge({}, {
                    render:  $.fn.dataTable.render.text()
                }, column);
            });
        }
    },
    data() {
        return {
            isCollapsed: false,

            defaultOptions: {
                select: {
                    enabled: false,
                    position: 'left',
                    title: ''
                },
                edit: {
                    enabled: false,
                    iconButton: false
                }
            },
            elementId: `datatable-${this.guid()}`,
            table: null,
            editingRow: false,
            rowToEdit: null,
            currentFilter: ''
        }
    },
    props: {
        columns: {
            type: Array,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        options : {
            type: Object,
            default: () => {
                return {};
            }
        },
        filterPosition: {
            type: String,
            default: filterPositions.right
        },
        datatableOptions: {
            type: Object,
            default: () => { 
                return {}; 
            }
        },
        datatableClasses: {
            type: Array,
            default: () => {
                return [];
            }
        }
    }
};
</script>

<style lang="scss" scoped src="./Style/data-table.scss">

</style>